import i18next from "i18next"

export const OWNER_PRIVATE_GENDER = 1
export const OWNER_COMPANY_GENDER = 2

const PRIVATE_GENDER_LABEL = "bike:owner.gender.private"
const COMPANY_GENDER_LABEL = "bike:owner.gender.company"

// GENDER FOR USERS
export const GENDER_OCODE_TECH = 9 // Super Admin Tech
export const GENDER_OCODE_SUPPORT = 10 // Super Admin Ocode
export const OCODE_GENDERS_LIST = [GENDER_OCODE_TECH, GENDER_OCODE_SUPPORT]
export const checkIsAdminOcode = (gender: number) => OCODE_GENDERS_LIST.includes(gender)

export const ADMIN_BICYCODE = 11
export const ADMIN_MFC = 12
export const ADMIN_MOUSTACHE = 14
export const CUSTOMER_GENDERS_LIST = [ADMIN_BICYCODE, ADMIN_MFC, ADMIN_MOUSTACHE]
export const checkIsAdminOperator = (gender: number) => CUSTOMER_GENDERS_LIST.includes(gender)
export const checkIsAdminBicycode = (gender: number) => gender === ADMIN_BICYCODE
export const checkIsAdminMFC = (gender: number) => gender === ADMIN_MFC
export const checkIsAdminMoustache = (gender: number) => gender === ADMIN_MOUSTACHE

export const ADMIN_GENDERS_LIST = [GENDER_OCODE_TECH, GENDER_OCODE_SUPPORT, ADMIN_BICYCODE, ADMIN_MFC, ADMIN_MOUSTACHE]
export const checkIsAdmin = (gender: number) => ADMIN_GENDERS_LIST.includes(gender)

// ACCOUNT STATUS
export const CREATED_ACCOUNT = 0
export const ACTIVATED_ACCOUNT = 1
export const SUSPENDED_ACCOUNT = 2
export const DELETED_ACCOUNT = 9

export const entityPermissionList = [
    { value: "MANAGEBIKES" },
    { value: "MANAGEENTITIES" }
]

export const userEntityGenderList = [
    { value: OWNER_PRIVATE_GENDER, label: PRIVATE_GENDER_LABEL },
    { value: OWNER_COMPANY_GENDER, label: COMPANY_GENDER_LABEL }
]
  
export const entitySpecificPermissionList = [
    { id: "superadmin", value: 0, label: "team:status.superadmin" },
    { id: "admin", value: 1, label: "team:status.admin" }
]
  
  export const entityGenderList = [
    { value: 9, id: "O°CODE TECH", operator_id: "ocode" },
    { value: 10, id: "O°CODE SUPP", operator_id: "ocode" },
    { value: 11, id: "BICYCODE", operator_id: "bicycode" },
    { value: 12, id: "MFC", operator_id: "mfc" },
    { value: 14, id: "MOUSTACHE", operator_id: "mc" },
]

// PERMISSION
export const SELLER_PERMISSION = 1

export const userPermissionList = [
    { id: "manager", value: -1, label: "team:status.manager" },
    { id: "admin", value: 0, label: "team:status.admin" },
    { id: "seller", value: SELLER_PERMISSION, label: "team:status.seller" }
]
export const profilStatusList = [
    { id: 0, value: 0, label: "team:status_profil.nonactivate" }, // non activé
    { id: 1, value: 1, label: "team:status_profil.activate" }, // activé
    { id: 2, value: 2, label: "team:status_profil.suspended" }, // suspendu
    { id: 9, value: 9, label: "team:status_profil.deleted" } // supprimé
]

export const profilPartnerStatusList = [
  { id: 0, value: 0, label: i18next.t("status_profil.waiting", { ns: "partner" }) },
  { id: 1, value: 1, label: i18next.t("status_profil.resend", { ns: "partner" }) },
  { id: 2, value: 2, label: i18next.t("status_profil.ask_elements", { ns: "partner" }) },
  { id: 9, value: 9, label: i18next.t("status_profil.refused", { ns: "partner" }) }
]

export const refusedPartnerStatusList = [
    { id: "not_eligible", value: 1, label: i18next.t("edit.not-eligible", { ns: "partner" }) },
    { id: "no_longer_interested", value: 2, label: i18next.t("edit.no-longer-interested", { ns: "partner" }) }
]

// export const enrolmentProcessList = [
//     { id: "gender", value: 1, label: i18next.t("create_account.gender_label", { ns: "user" }) },
//     { id: "partner-reference", value: 2, label: i18next.t("create_account.reference_label", { ns: "user" }) },
//     { id: "email", value: 3, label: i18next.t("create_account.email_label", { ns: "user" }) },
//     { id: "structure", value: 4, label: i18next.t("create_account.structure_label", { ns: "user" }) },
//     { id: "manager", value: 5, label: i18next.t("create_account.manager_label", { ns: "user" }) },
//     { id: "store", value: 6, label: i18next.t("create_account.shop_label", { ns: "user" }) },
//     { id: "password", value: 7, label: i18next.t("create_account.password_label", { ns: "user" }) },
//     { id: "success", value: 8, label: i18next.t("create_account.success_label", { ns: "user" }) },
//     { id: "bicycode-services", value: 9, label: i18next.t("create_account.bicycode_services_label", { ns: "user" }) }
//   ]